$(document).ready(function() {
  //console.log('Document ready fired');
  //console.log('Form exists:', $('.sign-up').length > 0);
  
  // Use both jQuery and standard JS to ensure the form doesn't submit
  $('.sign-up').on('submit', function(e) {
    console.log('Form submission intercepted');
    e.preventDefault();
    e.stopPropagation();
    
    var $form = $(this);
    var email = $('#nl-email').val().trim();
    var lastName = $('#name').val().trim();
    
    console.log('Form data:', { email: email, last_name: lastName });
    
    // Validate email
    if (!email) {
      console.log('Email is empty');
      return false;
    }
    
    var settings = {
      "async": true,
      "crossDomain": true,
      "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
      "method": "POST",
      "headers": {
        "content-type": "application/x-www-form-urlencoded",
        "cache-control": "no-cache"
      },
      "data": {
        "g": "YcAhTv",
        "email": email,
        "$fields": "$last_name",
        "$last_name": lastName
      }
    };

    // Log the AJAX request
    console.log('Sending request to Klaviyo:', settings);

    $.ajax(settings)
      .done(function(response) {
        console.log('Subscription successful', response);
        $('.nl-success-message').addClass('active');
      })
      .fail(function(jqXHR, textStatus, errorThrown) {
        console.error('Subscription failed:', {
          status: jqXHR.status,
          statusText: jqXHR.statusText,
          responseText: jqXHR.responseText
        });
      });
      
    return false; 
  });
});